import * as PIXI from 'pixi.js';
import { config } from './appConfig';
import gsap from "gsap"
import { Spine } from '@esotericsoftware/spine-pixi-v7'
import { globalData } from './globalData';

let grandWinDisplayAmount = 0;
let majorWinDisplayAmount = 0;
let minorWinDisplayAmount = 0;

export class jackpotPanel {

    jackpotPanelContainer = null;

    grandJackpotNumberArray = [];
    majorJackpotNumberArray = [];
    minorJackpotNumberArray = [];

    targetGrandWin = 0;
    targetMajorWin = 0;
    targetMinorWin = 0;

    _pauseDuration = 100

    constructor() {
        this.jackpotPanelContainer = new PIXI.Container();

        this.jackpotPanelSprite = new PIXI.Sprite(PIXI.Assets.get('jackpot-panel'))
        this.jackpotPanelSprite.anchor.set(0.5);
        this.jackpotPanelSprite.x = 0;
        this.jackpotPanelSprite.y = 0;
        this.jackpotPanelContainer.addChild(this.jackpotPanelSprite)

        this.setupJackpotSlots();
    }

    setupJackpotSlots() {
        this.grandJackpotHolder = new PIXI.Sprite(PIXI.Assets.get('grand-panel'))
        this.grandJackpotHolder.anchor.set(0.5);
        this.grandJackpotHolder.x = -195
        this.grandJackpotHolder.y = 20
        this.jackpotPanelSprite.addChild(this.grandJackpotHolder);

        this.grandJackpotText = new PIXI.Sprite(PIXI.Assets.get('grand-text'))
        this.grandJackpotText.x = -200
        this.grandJackpotText.y = -90
        this.grandJackpotText.anchor.set(0.5);
        this.grandJackpotText.scale.set(0.55);
        this.grandJackpotHolder.addChild(this.grandJackpotText);
        this.grandJackpotHolder.sortableChildren = true;

        this.grandJackpotMask = new PIXI.Graphics();
        this.grandJackpotMask.beginFill(0xffffff);
        this.grandJackpotMask.drawRect(-(this.grandJackpotHolder.width - 60) / 2, -(this.grandJackpotHolder.height - 60) / 2, this.grandJackpotHolder.width - 60, this.grandJackpotHolder.height - 60);  // Adjust position & size
        this.grandJackpotMask.endFill();
        this.grandJackpotHolder.addChild(this.grandJackpotMask);

        // setTimeout(() => {

        //     this.showGrandWin(1000000.54)
        // }, 10000);
        this.grandJackpotSpine = Spine.from({ skeleton: "jackpotPanelSpine", atlas: "jackpotPanelSpineAtlas" });
        this.grandJackpotSpine.x = config.logicalWidth / 2 - 615
        this.grandJackpotSpine.y = config.logicalHeight / 2 - 144
        this.grandJackpotSpine.scale.set(1)
        this.grandJackpotHolder.addChild(this.grandJackpotSpine);
        this.grandJackpotSpine.state.setAnimation(1, "grand_anticipation", true);
        // console.log("spine grand jackpot", this.grandJackpotSpine)
        this.grandJackpotSpine.zIndex = 1
        this.grandJackpotText.zIndex = 2


        this.majorJackpotHolder = new PIXI.Sprite(PIXI.Assets.get('major-panel'))
        this.majorJackpotHolder.anchor.set(0.5);
        this.majorJackpotHolder.x = 405
        this.majorJackpotHolder.y = -55
        this.jackpotPanelSprite.addChild(this.majorJackpotHolder);
        this.majorJackpotHolder.sortableChildren = true;

        this.majorJackpotText = new PIXI.Sprite(PIXI.Assets.get('major-text'))
        this.majorJackpotText.x = -90
        this.majorJackpotText.y = -43
        this.majorJackpotText.anchor.set(0.5);
        this.majorJackpotText.scale.set(1);
        this.majorJackpotHolder.addChild(this.majorJackpotText);

        this.majorJackpotMask = new PIXI.Graphics();
        this.majorJackpotMask.beginFill(0xffffff);
        this.majorJackpotMask.drawRect(-(this.majorJackpotHolder.width - 50) / 2, -(this.majorJackpotHolder.height - 50) / 2, this.majorJackpotHolder.width - 50, this.majorJackpotHolder.height - 50);  // Adjust position & size
        this.majorJackpotMask.endFill();
        this.majorJackpotHolder.addChild(this.majorJackpotMask);

        this.majorJackpotSpine = Spine.from({ skeleton: "jackpotPanelSpine", atlas: "jackpotPanelSpineAtlas" });
        this.majorJackpotSpine.x = -495
        this.majorJackpotSpine.y = 1210
        this.majorJackpotSpine.scale.set(1)
        this.majorJackpotHolder.addChild(this.majorJackpotSpine);
        this.majorJackpotSpine.state.setAnimation(1, "major_anticipation", true);

        this.majorJackpotSpine.zIndex = 1
        this.majorJackpotText.zIndex = 2
        // setTimeout(() => {
        //         this.showMajorWin(40000000.2)

        // }, 10000);

        this.minorJackpotHolder = new PIXI.Sprite(PIXI.Assets.get('minor-panel'))
        this.minorJackpotHolder.anchor.set(0.5);
        this.minorJackpotHolder.x = 405
        this.minorJackpotHolder.y = 55
        this.jackpotPanelSprite.addChild(this.minorJackpotHolder);
        this.minorJackpotHolder.sortableChildren = true;

        this.minorJackpotText = new PIXI.Sprite(PIXI.Assets.get('minor-text'))
        this.minorJackpotText.x = -90
        this.minorJackpotText.y = -43
        this.minorJackpotText.anchor.set(0.5);
        this.minorJackpotText.scale.set(1);
        this.minorJackpotHolder.addChild(this.minorJackpotText);

        this.minorJackpotMask = new PIXI.Graphics();
        this.minorJackpotMask.beginFill(0xffffff);
        this.minorJackpotMask.drawRect(-(this.minorJackpotHolder.width - 50) / 2, -(this.minorJackpotHolder.height - 50) / 2, this.minorJackpotHolder.width - 50, this.minorJackpotHolder.height - 50);  // Adjust position & size
        this.minorJackpotMask.endFill();
        this.minorJackpotHolder.addChild(this.minorJackpotMask);

        this.minorJackpotSpine = Spine.from({ skeleton: "jackpotPanelSpine", atlas: "jackpotPanelSpineAtlas" });
        this.minorJackpotSpine.x = -495
        this.minorJackpotSpine.y = 1100
        this.minorJackpotSpine.scale.set(1)
        this.minorJackpotHolder.addChild(this.minorJackpotSpine);
        this.minorJackpotSpine.state.setAnimation(1, "minor_anticipation", true);

        this.minorJackpotSpine.zIndex = 1
        this.minorJackpotText.zIndex = 2

        // setTimeout(() => {
        //     this.showMinorWin(12352320.54)
        // }, 10000);
        //  this.showMinorWin(12350.54)

    }

    checkNumberMatch = (array, targetValue) => {
        const numberString = array.map(digitText => digitText.text).join(""); // Join digits
        const parsedNumber = parseFloat(numberString.replace(/,/g, '')); // Convert to number

        targetValue = Math.round(targetValue * 100) / 100; // Round targetValue to 2 decimal places
        console.log(`Displayed: ${parsedNumber}, Target: ${targetValue}`);

        return Math.abs(parsedNumber - targetValue) < 0.00001; // Use a small threshold
    };


    resetPanel() {
        // globalData.grandCurrentJackpotValue = globalData.resetGrandJackpotValue;
        // globalData.majorCurrentJackpotValue = globalData.resetMajorJackpotValue;
        // globalData.minorCurrentJackpotValue = globalData.resetMinorJackpotValue;
        this.showGrandWin(globalData.grandFlag ? globalData.grandCurrentJackpotValue : globalData.resetGrandJackpotValue, 0.1 , false)
        this.showMajorWin(globalData.majorFlag ? globalData.majorCurrentJackpotValue : globalData.resetMajorJackpotValue, 0.1 , false)
        this.showMinorWin(globalData.grandFlag ? globalData.minorCurrentJackpotValue : globalData.resetMinorJackpotValue, 0.1 , false)
        // grandWinDisplayAmount = 0;
        // majorWinDisplayAmount = 0;
        // minorWinDisplayAmount = 0;
        // this.grandJackpotNumberArray = [];
        // this.majorJackpotNumberArray = [];
        // this.minorJackpotNumberArray = [];
        globalData.majorFlag = globalData.minorFlag = globalData.grandFlag = false;
        this.hideAllWinSpines();
    }

    showGrandWinSpine() {
        this.grandJackpotSpine.visible = true;
        this.grandJackpotSpine.state.setAnimation(1, "grand_win", true);
    }

    showMajorWinSpine() {
        this.majorJackpotSpine.visible = true;
        this.majorJackpotSpine.state.setAnimation(1, "major_win", true);
    }
    showMinorWinSpine() {
        this.minorJackpotSpine.visible = true;
        this.minorJackpotSpine.state.setAnimation(1, "minor_win", true);
    }

    hideGrandWinSpine() {
        this.grandJackpotSpine.visible = false;
        this.grandJackpotSpine.state.setAnimation(1, "grand_win", false);
    }

    hideMajorWinSpine() {
        this.majorJackpotSpine.visible = false;
        this.majorJackpotSpine.state.setAnimation(1, "major_win", false);
    }
    hideMinorWinSpine() {
        this.minorJackpotSpine.visible = false;
        this.minorJackpotSpine.state.setAnimation(1, "minor_win", false);
    }

    hideAllWinSpines() {
        this.grandJackpotSpine.visible = false;
        this.grandJackpotSpine.state.setAnimation(1, "grand_win", false);
        this.majorJackpotSpine.visible = false;
        this.majorJackpotSpine.state.setAnimation(1, "major_win", false);
        this.minorJackpotSpine.visible = false;
        this.minorJackpotSpine.state.setAnimation(1, "minor_win", false);
    }

    hideAnticipationAnimation() {
        this.grandJackpotSpine.state.setAnimation(1, "grand_anticipation", false);
        this.majorJackpotSpine.state.setAnimation(1, "major_anticipation", false);
        this.minorJackpotSpine.state.setAnimation(1, "minor_anticipation", false);
    }


    showGrandWin(winAmount = 1000000, duration = 5, animation = true) {
        this.targetGrandWin = winAmount;
        this.countUpGrand(winAmount, duration)
        this.splitGrandNumberToDigits(grandWinDisplayAmount);
        if (winAmount > 0 && animation) {
            this.grandJackpotSpine.state.setAnimation(1, "grand_anticipation", true);
            this.grandJackpotSpine.visible = true;
        }
        // setTimeout(() => {
        //     this.splitGrandNumberToDigits(winAmount);
        // }, 100);
    }

    countUpGrand = (targetValue, duration) => {
        let obj = { value: grandWinDisplayAmount }; // Temporary object for animation

        gsap.to(obj, {
            value: targetValue,
            duration: duration,
            ease: "power2.out",
            onUpdate: () => {
                let decimalCount = (targetValue % 1 !== 0) ? 2 : 0; // Check if target has decimals

                grandWinDisplayAmount = obj.value.toFixed(decimalCount); // Format accordingly

                //console.log(grandWinDisplayAmount); // Log updated value
            }
        });
    };



    clearGrandArray() {
        this.grandJackpotNumberArray.forEach(element => {
            this.grandJackpotHolder.removeChild(element);
        })
        this.grandJackpotNumberArray = [];
        this.grandJackpotNumberArray.length = 0;
    }

    splitGrandNumberToDigits(number) {
        if (number === null || number === undefined || isNaN(number)) {
            // console.error("Invalid number input:", number);
            return;
        }

        if (this.grandJackpotNumberArray.length) this.clearGrandArray();

        this.grandJackpotNumberArray = []; // Reset properly

        // Ensure at least "0" is visible
        let numStr = number.toString().trim();
        let parts = numStr.split('.'); // Separate integer and decimal parts
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

        let splitDigits = integerPart.split('').reverse();
        let formatted = [];

        for (let i = 0; i < splitDigits.length; i++) {
            if (i > 0 && i % 3 === 0) {
                formatted.push(',');
            }
            formatted.push(splitDigits[i]);
        }

        numStr = formatted.reverse().join('') + decimalPart;

        const numbers = numStr.split("").map(digit => {
            return digit === "." || digit === "," ? digit : isNaN(digit) ? 0 : digit; // Keep "." and "," as they are
        });

        const digitSpacing = 55; // Space between digits
        const totalWidth = numbers.length * digitSpacing; // Total width of the number
        const startX = -(totalWidth / 2) + digitSpacing; // Start position for centering

        // Remove existing currency symbol if it exists
        if (this.currencySymbol) {
            this.grandJackpotHolder.removeChild(this.currencySymbol);
            this.currencySymbol.destroy(); // Properly clean up the old symbol
        }

        // Create a single "₱" symbol
        this.currencySymbol = new PIXI.BitmapText("₱", {
            fontName: 'jackpot_bitmap-fnt-export',
            fontSize: 19,
            align: 'center'
        });

        this.currencySymbol.anchor.set(0.5);
        this.currencySymbol.y = -20;
        this.currencySymbol.x = startX - digitSpacing - 8; // Position it before the first digit
        this.grandJackpotHolder.addChild(this.currencySymbol);

        numbers.forEach((element, index) => {
            const digitText = new PIXI.BitmapText(element.toString(), {
                fontName: 'jackpot_bitmap-fnt-export',
                fontSize: 19,
                align: 'center',
                letterSpacing: 0,
            });

            digitText.anchor.set(0.5);
            digitText.y = -20;
            digitText.x = startX + index * digitSpacing; // Adjust X to center the digits

            this.grandJackpotHolder.addChild(digitText);
            this.grandJackpotNumberArray[index] = digitText;

            if (this.grandJackpotMask) {
                this.grandJackpotNumberArray[index].mask = this.grandJackpotMask;
            } else {
                // console.error("Mask is not defined before assignment");
            }
        });

        this.playDownAnimation1(this.grandJackpotNumberArray, 0);
    }






    playDownAnimation1(array, index, offsetY, pauseY) {
        array[index].y = -100

        gsap.to(array[index], {
            y: array[index].y + 85,
            duration: 0.07,
            onComplete: () => {
                if (array[index + 1]) {
                    this.playDownAnimation1(array, index + 1);
                }
                else {
                    //console.log(this.targetGrandWin)
                    if (this.checkNumberMatch(array, this.targetGrandWin)) {
                        // grandWinDisplayAmount = 0;
                        this.grandJackpotSpine.state.setAnimation(1, "grand_anticipation", false);
                        this.grandJackpotSpine.visible = false;
                        if (globalData.jackpotGrandWinAmount) {
                            //    this.showGrandWinSpine();
                        }
                        return;
                    }
                    //console.log(this.targetGrandWin)
                    setTimeout(() => {
                        this.playDownAnimation2(array, 0);
                    }, this._pauseDuration);
                }
            }
        })
    }
    playDownAnimation2(array, index) {
        gsap.to(array[index], {
            y: array[index].y + 100,
            duration: 0.07,
            onComplete: () => {
                if (array[index + 1])
                    this.playDownAnimation2(array, index + 1);
                else
                    this.splitGrandNumberToDigits(grandWinDisplayAmount)
            }
        })
    }

    //TODO: MAJOR
    showMajorWin(winAmount = 1000000, duration = 5, animation = true) {
        this.targetMajorWin = winAmount;
        this.countUpMajor(winAmount, duration)
        this.splitMajorNumberToDigits(majorWinDisplayAmount);
        if (winAmount > 0 && animation) {
            this.majorJackpotSpine.state.setAnimation(1, "major_anticipation", true);
            this.majorJackpotSpine.visible = true;
        }
        // setTimeout(() => {
        //     this.splitGrandNumberToDigits(winAmount);
        // }, 100);
    }

    countUpMajor = (targetValue, duration) => {
        let obj = { value: majorWinDisplayAmount }; // Temporary object for animation

        gsap.to(obj, {
            value: targetValue,
            duration: duration,
            ease: "power2.out",
            onUpdate: () => {
                let decimalCount = (targetValue % 1 !== 0) ? 2 : 0; // Check if target has decimals

                majorWinDisplayAmount = obj.value.toFixed(decimalCount); // Format accordingly

                // //console.log(grandWinDisplayAmount); // Log updated value
            }
        });
    };

    clearMajorArray() {
        this.majorJackpotNumberArray.forEach(element => {
            this.majorJackpotHolder.removeChild(element);
        })
        this.majorJackpotNumberArray = [];
        this.majorJackpotNumberArray.length = 0;
    }

    splitMajorNumberToDigits(number) {
        if (number === null || number === undefined || isNaN(number)) {
            // console.error("Invalid number input:", number);
            return;
        }

        if (this.majorJackpotNumberArray.length) this.clearMajorArray();

        this.majorJackpotNumberArray = []; // Reset properly

        // Ensure at least "0" is visible
        let numStr = number.toString().trim();
        let parts = numStr.split('.'); // Separate integer and decimal parts
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

        let splitDigits = integerPart.split('').reverse();
        let formatted = [];

        for (let i = 0; i < splitDigits.length; i++) {
            if (i > 0 && i % 3 === 0) {
                formatted.push(',');
            }
            formatted.push(splitDigits[i]);
        }

        numStr = formatted.reverse().join('') + decimalPart;

        const numbers = numStr.split("").map(digit => {
            return digit === "." || digit === "," ? digit : isNaN(digit) ? 0 : digit; // Keep "." and "," as they are
        });

        const digitSpacing = 28; // Space between digits
        const totalWidth = numbers.length * digitSpacing; // Total width of the number
        const startX = -(totalWidth / 2) + digitSpacing; // Start position for centering

        // Remove existing currency symbol if it exists
        if (this.currencySymbol2) {
            this.majorJackpotHolder.removeChild(this.currencySymbol2);
            this.currencySymbol2.destroy(); // Properly clean up the old symbol
        }

        // Create a single "₱" symbol
        this.currencySymbol2 = new PIXI.BitmapText("₱", {
            fontName: 'jackpot_bitmap-fnt-export',
            fontSize: 10,
            align: 'center'
        });

        this.currencySymbol2.anchor.set(0.5);
        this.currencySymbol2.y = -7;
        this.currencySymbol2.x = startX - digitSpacing - 8; // Position it before the first digit
        this.majorJackpotHolder.addChild(this.currencySymbol2);

        numbers.forEach((element, index) => {
            const digitText = new PIXI.BitmapText(element.toString(), {
                fontName: 'jackpot_bitmap-fnt-export',
                fontSize: 10,
                align: 'center',
                letterSpacing: 0,
            });

            digitText.anchor.set(0.5);
            digitText.y = -20;
            digitText.x = startX + index * digitSpacing; // Adjust X to center the digits

            this.majorJackpotHolder.addChild(digitText);
            this.majorJackpotNumberArray[index] = digitText;

            if (this.majorJackpotMask) {
                this.majorJackpotNumberArray[index].mask = this.majorJackpotMask;
            } else {
                // console.error("Mask is not defined before assignment");
            }
        });

        this.playDownAnimation3(this.majorJackpotNumberArray, 0);
    }


    playDownAnimation3(array, index, offsetY, pauseY) {
        array[index].y = -40

        gsap.to(array[index], {
            y: array[index].y + 35,
            duration: 0.07,
            onComplete: () => {
                if (array[index + 1]) {
                    this.playDownAnimation3(array, index + 1);
                }
                else {
                    if (this.checkNumberMatch(array, this.targetMajorWin)) {
                        //   majorWinDisplayAmount = 0;
                        this.majorJackpotSpine.state.setAnimation(1, "major_anticipation", false);
                        this.majorJackpotSpine.visible = false;
                        if (globalData.jackpotMajorWinAmount) {
                            // this.showMajorWinSpine();
                        }
                        return;
                    }
                    setTimeout(() => {
                        this.playDownAnimation4(array, 0);
                    }, this._pauseDuration);
                }
            }
        })
    }
    playDownAnimation4(array, index) {
        gsap.to(array[index], {
            y: array[index].y + 100,
            duration: 0.07,
            onComplete: () => {
                if (array[index + 1])
                    this.playDownAnimation4(array, index + 1);
                else
                    this.splitMajorNumberToDigits(majorWinDisplayAmount)
            }
        })
    }


    showMinorWin(winAmount = 1000000, duration = 5, animation = true) {
        this.targetMinorWin = winAmount;
        this.countUpMinor(winAmount, duration)
        this.splitMinorNumberToDigits(minorWinDisplayAmount);
        if (winAmount > 0 && animation) {
            this.minorJackpotSpine.state.setAnimation(1, "minor_anticipation", true);
            this.minorJackpotSpine.visible = true
        }
    }

    countUpMinor = (targetValue, duration) => {
        let obj = { value: minorWinDisplayAmount }; // Temporary object for animation

        gsap.to(obj, {
            value: targetValue,
            duration: duration,
            ease: "power2.out",
            onUpdate: () => {
                let decimalCount = (targetValue % 1 !== 0) ? 2 : 0; // Check if target has decimals

                minorWinDisplayAmount = obj.value.toFixed(decimalCount); // Format accordingly

                //  //console.log(grandWinDisplayAmount); // Log updated value
            }
        });
    };

    clearMinorArray() {
        this.minorJackpotNumberArray.forEach(element => {
            this.minorJackpotHolder.removeChild(element);
        })
        this.minorJackpotNumberArray = [];
        this.minorJackpotNumberArray.length = 0;
    }

    splitMinorNumberToDigits(number) {
        if (number === null || number === undefined || isNaN(number)) {
            // console.error("Invalid number input:", number);
            return;
        }

        if (this.minorJackpotNumberArray.length) this.clearMinorArray();

        this.minorJackpotNumberArray = []; // Reset properly

        // Ensure at least "0" is visible
        let numStr = number.toString().trim();
        let parts = numStr.split('.'); // Separate integer and decimal parts
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

        let splitDigits = integerPart.split('').reverse();
        let formatted = [];

        for (let i = 0; i < splitDigits.length; i++) {
            if (i > 0 && i % 3 === 0) {
                formatted.push(',');
            }
            formatted.push(splitDigits[i]);
        }

        numStr = formatted.reverse().join('') + decimalPart;

        const numbers = numStr.split("").map(digit => {
            return digit === "." || digit === "," ? digit : isNaN(digit) ? 0 : digit; // Keep "." and "," as they are
        });

        const digitSpacing = 28; // Space between digits
        const totalWidth = numbers.length * digitSpacing; // Total width of the number
        const startX = -(totalWidth / 2) + digitSpacing; // Start position for centering

        // Remove existing currency symbol if it exists
        if (this.currencySymbol3) {
            this.minorJackpotHolder.removeChild(this.currencySymbol3);
            this.currencySymbol3.destroy(); // Properly clean up the old symbol
        }

        // Create a single "₱" symbol
        this.currencySymbol3 = new PIXI.BitmapText("₱", {
            fontName: 'jackpot_bitmap-fnt-export',
            fontSize: 10,
            align: 'center'
        });

        this.currencySymbol3.anchor.set(0.5);
        this.currencySymbol3.y = -5;
        this.currencySymbol3.x = startX - digitSpacing - 8; // Position it before the first digit
        this.minorJackpotHolder.addChild(this.currencySymbol3);

        numbers.forEach((element, index) => {
            const digitText = new PIXI.BitmapText(element.toString(), {
                fontName: 'jackpot_bitmap-fnt-export',
                fontSize: 10,
                align: 'center',
                letterSpacing: 0,
            });

            digitText.anchor.set(0.5);
            digitText.y = -20;
            digitText.x = startX + index * digitSpacing; // Adjust X to center the digits

            this.minorJackpotHolder.addChild(digitText);
            this.minorJackpotNumberArray[index] = digitText;

            if (this.minorJackpotMask) {
                this.minorJackpotNumberArray[index].mask = this.minorJackpotMask;
            } else {
                // console.error("Mask is not defined before assignment");
            }
        });

        this.playDownAnimation5(this.minorJackpotNumberArray, 0);
    }


    playDownAnimation5(array, index) {
        array[index].y = -90

        gsap.to(array[index], {
            y: array[index].y + 85,
            duration: 0.07,
            onComplete: () => {
                if (array[index + 1]) {
                    this.playDownAnimation5(array, index + 1);
                }
                else {
                    if (this.checkNumberMatch(array, this.targetMinorWin)) {
                        // minorWinDisplayAmount = 0;
                        this.minorJackpotSpine.state.setAnimation(1, "minor_anticipation", false);
                        this.minorJackpotSpine.visible = false;
                        if (globalData.jackpotMinorWinAmount) {
                            //  this.showMinorWinSpine();
                        }
                        return;
                    }
                    setTimeout(() => {
                        this.playDownAnimation6(array, 0);
                    }, this._pauseDuration);
                }
            }
        })
    }

    playDownAnimation6(array, index) {
        gsap.to(array[index], {
            y: array[index].y + 50,
            duration: 0.07,
            onComplete: () => {
                if (array[index + 1])
                    this.playDownAnimation6(array, index + 1);
                else
                    this.splitMinorNumberToDigits(minorWinDisplayAmount)
            }
        })
    }

}